import { TFunction } from 'i18next';

import { ActionInputContextType } from '@bonusly/common-action-input';

export interface VideoModalText {
	heading: string;
	submitButton: string;
	restartButton: string;
	downloadButton: string;
}

export const getVideoModalText = (contextType: ActionInputContextType, t: TFunction): VideoModalText => {
	switch (contextType) {
		case ActionInputContextType.Recognition:
			return {
				heading: t('modal.heading'),
				submitButton: t('modal.actions.add_to_bonus'),
				restartButton: t('modal.actions.restart'),
				downloadButton: t('modal.actions.download'),
			};
		case ActionInputContextType.TemplatedAward:
		case ActionInputContextType.NonTemplatedAward:
			return {
				heading: t('modal.heading_award'),
				submitButton: t('modal.actions.attach_to_award'),
				restartButton: t('modal.actions.restart'),
				downloadButton: t('modal.actions.download'),
			};
		case ActionInputContextType.Comment:
			return {
				heading: t('modal.heading_comment'),
				submitButton: t('modal.actions.add_to_comment'),
				restartButton: t('modal.actions.restart'),
				downloadButton: t('modal.actions.download'),
			};
		default:
			return {
				heading: t('modal.heading'),
				submitButton: t('modal.actions.add_to_bonus'),
				restartButton: t('modal.actions.restart'),
				downloadButton: t('modal.actions.download'),
			};
	}
};
